import { footerGroups, footerMeta, siteName } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-search-eye-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteName}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">{footerMeta}</p>

            <div className="mt-5 flex gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-rss-line'].map((icon, i) => (
                <a
                  key={`${icon}-${i}`}
                  href="#top"
                  aria-label="社区渠道"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerGroups.map((group) => (
              <div key={group.name}>
                <h3 className="text-sm font-semibold text-foreground-950">{group.name}</h3>
                <ul className="mt-4 space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteName} · 保留所有权利</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-sm" />
            内容基于公开信息整理，供讨论与参考
          </p>
        </div>
      </div>
    </footer>
  );
}